import { forwardRef } from 'react';

const CIRCLE = {
  SIZE: 120,
  RADIUS: 30,
};

export default forwardRef<HTMLDivElement>(
  function ProgressContainer(_props, ref) {
    return (
      <div className="progress-container" ref={ref}>
        <div className="progress relative">
          <svg
            className="progress-ring"
            width={CIRCLE.SIZE}
            height={CIRCLE.SIZE}
          >
            <circle
              className="progress-ring-circle-remaining"
              stroke="#ccc" // Gray color for remaining portion
              strokeWidth="8"
              fill="transparent"
              r={CIRCLE.RADIUS}
              cx={CIRCLE.SIZE / 2}
              cy={CIRCLE.SIZE / 2}
            />
            <circle
              className="progress-ring-circle-completed"
              stroke="#007bff"
              strokeWidth="8"
              fill="transparent"
              r={CIRCLE.RADIUS}
              cx={CIRCLE.SIZE / 2}
              cy={CIRCLE.SIZE / 2}
              style={{
                display: 'none',
                strokeDashoffset: 0, // No offset for remaining portion
                transition: 'stroke-dashoffset 0.3s ease-in-out',
              }}
            />
          </svg>
          <div className="progress-label text-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            0%
          </div>
        </div>
      </div>
    );
  },
);
